export class UpdateFamilyHistoryType {

    // private to disallow creating other instances of this type
    private constructor(private readonly key: string, public readonly value: any) {
    }

    getKey() {
        return this.key;
    }

    getValue() {
        return this.value;
    }

    static retrieveValueByKey(key: string): string {
        switch (key) {
            case this.EDIT_PERSON.getKey():
                return this.EDIT_PERSON.getValue();
            case this.ADD_PERSON.getKey():
                return this.ADD_PERSON.getValue();
            case this.ATTENDING_STATUS.getKey():
                return this.ATTENDING_STATUS.getValue();
            case this.REMOVE_PERSON.getKey():
                return this.REMOVE_PERSON.getValue();
            case this.BRUNCH_STATUS.getKey():
                return this.BRUNCH_STATUS.getValue();
            default:
                return '';
        }
    }

    static retrieveKeyByValue(value: string): string {
        switch (value) {
            case this.EDIT_PERSON.getValue():
                return this.EDIT_PERSON.getKey();
            case this.REMOVE_PERSON.getValue():
                return this.REMOVE_PERSON.getKey();
            case this.ATTENDING_STATUS.getValue():
                return this.ATTENDING_STATUS.getKey();
            case this.ADD_PERSON.getValue():
                return this.ADD_PERSON.getKey();
            case this.BRUNCH_STATUS.getValue():
                return this.BRUNCH_STATUS.getKey();
            default:
                return '';
        }
    }

    static readonly ADD_PERSON = new UpdateFamilyHistoryType('ADD_PERSON', 'Ajout d\'un invité');
    static readonly EDIT_PERSON = new UpdateFamilyHistoryType('EDIT_PERSON', 'Modification d\'un invité');
    static readonly REMOVE_PERSON = new UpdateFamilyHistoryType('REMOVE_PERSON', 'Suppression d\'un invité');
    static readonly ATTENDING_STATUS = new UpdateFamilyHistoryType('ATTENDING_STATUS', 'Modification de la présence au mariage');
    static readonly BRUNCH_STATUS = new UpdateFamilyHistoryType('BRUNCH_STATUS', 'Modification de la présence au brunch');

}
